import type { ReactNode } from 'react';
import { useT } from '../i18n';
import '../styles/screens.css';

interface ErrorBannerProps {
  message: string | null;
  onDismiss?: () => void;
}

export function ErrorBanner({ message, onDismiss }: ErrorBannerProps): ReactNode {
  const t = useT();
  if (!message) return null;

  return (
    <div className="error-banner" role="alert">
      <span>{message}</span>
      {onDismiss && (
        <button
          className="error-banner__dismiss"
          onClick={onDismiss}
          aria-label={t('errorBanner.dismissAriaLabel')}
        >
          &times;
        </button>
      )}
    </div>
  );
}
